import Component from "../../component.abstract";

interface Passwords {
    password: string;
    new: string;
}

export default class AdvancedPassword extends Component {
    private currentPasswordWrapper: HTMLElement;
    private currentPasswordTitle: HTMLElement;
    private currentPassword: HTMLInputElement;
    private newPasswordTitle: HTMLElement;
    private newPassword: HTMLInputElement;
    private toggleExpand: HTMLElement;
    private toggleCollapse: HTMLElement;
    private ariaExpand: NodeListOf<Element>;
    private togglePasswordVisibility: NodeListOf<Element>;

    constructor( private props:unknown, element:HTMLElement) {
         super(props, element)

    }
    mounted():void {
        this.injectTemplate();

        this.currentPasswordWrapper = this.element.querySelector("[data-ap-current-wrapper]");
        this.currentPasswordTitle = this.element.querySelector("[data-ap-current-password-title]");
        this.currentPassword = this.element.querySelector("[data-ap-current]");
        this.newPasswordTitle = this.element.querySelector("[data-ap-new-password-title]");
        this.newPassword = this.element.querySelector("[data-ap-new]");
        this.toggleExpand = this.element.querySelector("[data-ap-expand]");
        this.toggleCollapse = this.element.querySelector("[data-ap-collapse]");
        this.togglePasswordVisibility = this.element.querySelectorAll("[data-ap-eyes]");
        this.ariaExpand = this.element.querySelectorAll("[aria-expanded]");

        this.toggleExpand.addEventListener("click",() => {
            this.expand()
        })
        this.toggleCollapse.addEventListener("click",() => {
            this.collapse()
        })
        // Handle clicks on [data-ap-eyes]
        this.togglePasswordVisibility.forEach((item, index) => {
            item.addEventListener("click", (event) => {
                this.showPassword(event);
            });
        });

        this.setPasswordStrengthMeterTemplate()

        this.newPassword.addEventListener("keyup", () => this.onPasswordKeyUp())
        this.newPassword.addEventListener('input', (e) => this.onPasswordInput(e))
        this.newPassword.addEventListener('blur', (e) => this.onPasswordBlur(e))
    }
    expand():void {
        this.element.classList.add("advancedPassword--expanded");
        this.currentPasswordTitle.innerText = "Mot de passe actuel";
        this.toggleExpand.style.display = "none";
        this.currentPassword.removeAttribute("disabled");
        this.currentPassword.removeAttribute("placeholder");
        // Accessibility
        this.setAriaAttributes(this.ariaExpand, true);
    }
    collapse():void {
        this.element.classList.remove("advancedPassword--expanded");
        this.currentPasswordTitle.innerText = "Mot de passe";
        this.toggleExpand.style.display = "block";
        this.setValue("");
        this.currentPassword.setAttribute("disabled", "");
        this.currentPassword.setAttribute("placeholder", "•••••••••");
        this.resetHelper(this.currentPassword);
        this.resetHelper(this.newPassword);
        // Accessibility
        this.setAriaAttributes(this.ariaExpand, false);
    }
    showPassword(event:Event):void {
       event.preventDefault();
       event.stopImmediatePropagation();

        const input = (<HTMLElement>event.currentTarget).parentElement.querySelector<HTMLInputElement>(".advancedPassword__input");

        (<HTMLElement>event.currentTarget).classList.toggle("advancedPassword__toggle--show");
        input.type = (input.type === "password") ? "text" : "password";
    }
    setAriaAttributes(elements: NodeListOf<Element>, status:boolean):void {
         elements.forEach(function (el, index) {
            el.setAttribute("aria-expanded", status.toString());
        });
    }
    setValue(password:string):void {
       this.currentPassword.value = password;
       this.newPassword.value = "";
    }
    getValues():Passwords {
        return {
            "password": this.currentPassword.value,
            "new": this.newPassword.value
        };
    }
    resetHelper(element: HTMLInputElement):void {
        element.parentElement.querySelector(".advancedPassword__toggle").classList.remove("advancedPassword__toggle--enabled", "advancedPassword__toggle--show");
        element.type = "password";
    }
    // Deploy a single input for user who hasn't already set a password
    simplePassword():void {
        this.element.classList.add("advancedPassword--expanded");
        this.currentPasswordWrapper.style.display = "none";
        this.newPasswordTitle.innerText = "Créer votre mot de passe";
        this.toggleCollapse.style.display = "none";
    }
    simplePasswordReset():void {
        this.currentPasswordWrapper.style.cssText = "";
        this.newPasswordTitle.innerText = "Nouveau mot de passe";
        this.toggleCollapse.style.cssText = "";
    }
    setPasswordStrengthMeterTemplate():void {
        const wrapper = document.createElement("div");
        wrapper.className = "password-strength-meter";
        const progressBar = document.createElement("div");
        progressBar.className = "password-strength-meter__progress-bar";
        const progressLevel = document.createElement("div");
        progressLevel.className = "progress-level";
        const progressLabel =  document.createElement("div");
        progressLabel.className = "password-strength-meter__label";
        const progressTooltip = document.createElement("div");
        progressTooltip.className = "password-strength-meter__label__tooltip";
        const progressTooltipLevel = document.createElement("span");
        progressTooltipLevel.className = "tooltip-level";
        const tooltipContent = document.createElement("div");
        tooltipContent.className = "password-strength-meter__label__tooltip__content";
        const tooltipText = "Pour sécuriser votre mot de passe, saisissez au moins 8 caractères et utilisez des majuscules, minuscules, chiffres et caractères spéciaux.";

        tooltipContent.textContent = tooltipText;
        progressTooltip.appendChild(progressTooltipLevel);
        progressTooltip.appendChild(tooltipContent);
        progressLabel.appendChild(progressTooltip);
        progressBar.appendChild(progressLevel);

        wrapper.appendChild(progressBar)
        wrapper.appendChild(progressLabel)
        
        this.newPassword.after(wrapper)
    }
    onPasswordKeyUp () {
        this.element.classList.add("with-strengh-meter");
    }
    onPasswordInput (inputEvent: Event) {
        const value = (inputEvent.target as HTMLInputElement).value
        const progressLevel = this.element.querySelector('.progress-level')
        const tooltipLevel = this.element.querySelector('.tooltip-level')

        if (value.length === 0) {
            progressLevel.className =  'progress-level';
            tooltipLevel.className = 'tooltip-level';
        } else {
            let strength = window.zxcvbn(value).score
            // No check improve level
            if (strength === 4) {
                strength--
            }

            progressLevel.className = `progress-level level${strength}`
            tooltipLevel.className = `tooltip-level level${strength}`
        }
    }
    onPasswordBlur (inputEvent: FocusEvent) {
        const element = inputEvent.target as HTMLInputElement
        const strength = window.zxcvbn(element.value).score 

        if (strength < 2) {
            element.classList.add('input-validation-error')
        }
    }
}